<template>
  <div class="text-center">
    <h2>{{ $t('logoutComplete') }}</h2>
    <div class="ma-4">
      <v-btn link x-large @click="login" color="primary">
        {{ $t('login') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/auth.service'

export default {
  methods: {
    login() {
      AuthService.login()
    }
  }
}
</script>

<style></style>
